import { Button, Kind } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import { useFormModel } from '../FormModel'
import Card from './Card'
import MoneyInput from './MoneyInput'
import NextButton from './NextButton'

const t = buildTranslate(
  'redeem_manager.builder.steps.configuration.minimum_spend_card'
)

type Props = {
  isOpen: boolean
  isCurrent: boolean
  onNext: () => void
}

const MinimumSpendCard = ({ isOpen, isCurrent, onNext }: Props) => {
  const [css] = useStyletron()
  const { model, setModel, commitModel } = useFormModel()
  // null = disabled; '' / numeric = enabled.
  const isEnabled = model.minimum !== null

  const toggle = () => {
    const updateModel = commitModel ?? setModel
    updateModel({ ...model, minimum: isEnabled ? null : '' })
  }

  return (
    <Card title={t('title')} isOpen={isOpen}>
      <div className="d-flex justify-content-between align-items-center mb-s">
        <Text.BodyText4 color="grey70" tag="span">
          {t(
            model.typeItem?.key === 'delivery_discount'
              ? 'delivery_description'
              : 'description'
          )}
        </Text.BodyText4>
        <Button
          kind={Kind.MINIMAL}
          onClick={toggle}
          aria-label={
            isEnabled ? t('disable_aria_label') : t('enable_aria_label')
          }
        >
          {isEnabled ? t('disable') : t('enable')}
        </Button>
      </div>
      {isEnabled && (
        <>
          <label
            htmlFor="minimum-spend-input"
            className={`d-block mb-xxs ${css({
              fontSize: '14px',
              fontWeight: 600,
              color: palette.grey90,
            })}`}
          >
            {t('amount_label')}
          </label>
          <MoneyInput
            id="minimum-spend-input"
            ariaLabel={t('input_aria_label')}
            value={model.minimum ?? ''}
            onChange={minimum => {
              const updateModel = commitModel ?? setModel
              updateModel({ ...model, minimum })
            }}
          />
        </>
      )}
      {isCurrent && (
        <div className="d-flex justify-content-end mt-m">
          <NextButton
            disabled={isEnabled && model.minimum === ''}
            onClick={onNext}
          />
        </div>
      )}
    </Card>
  )
}

export default MinimumSpendCard
